var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper",staticStyle:{"margin-bottom":"300px"}},[(_vm.basicInfoPropsData)?_c('app-breadcrumb',{attrs:{"page-title":`Parent Interview Form - <a href='/transaction/profile-lead/${_vm.basicInfoPropsData?.id}' class='text-primary' style='text-decoration:underline;'>${_vm.basicInfoPropsData?.lead_id_number}</a>`},domProps:{"innerHTML":_vm._s(_vm.pageTitle)}}):_vm._e(),_vm._v(" "),(
				_vm.basicInfoPropsData || 
				_vm.languagePropsData ||
				_vm.schoolPropsData ||
				_vm.consentPropsData
			)?_c('div',{staticClass:"card p-primary border-0"},[_c('parent-interview-form-wizard',{attrs:{"tabs":_vm.computedTabs}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }